import React, {useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";
import {setSendData} from "../../../Store/Slice/scheduleSlice";
import showToast from "../../../Global/Hooks/toast";

const tooltipText =
  "To improve your experience it is strongly advised that technicians familiarize themselves with this information to ensure readiness for handling various vehicle types and documenting which products go into each vehicle. Neglecting to provide this information may result in delayed installations while on site.";

export default function VehicleInfo() {
  const accountData = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  const fileInputRef = useRef();

  const filesData = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData.files
  );
  const filesDataVehicle = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData.vehicle_files
  );
  const dispatch = useDispatch();
  const uploadHandler = (event) => {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 10) {
        showToast("The file is too large. Maximum size: 10 MB.", 'error');
      } else {
        dispatch(setSendData({files: files}));
      }
    }
  };
  const uploadHandlerVehicle = (event) => {
    const vehicle_files = event.target.files;
    for (let i = 0; i < vehicle_files.length; i++) {
      const file = vehicle_files[i];
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 10) {
        showToast("The file is too large. Maximum size: 10 MB.", 'error');
      } else {
        dispatch(setSendData({vehicle_files: vehicle_files}));
      }
    }
  };
  const handleRemoveFile = (index) => {
    let newArray = Array.from(filesData).filter((elem, idx) => index !== idx);
    dispatch(setSendData({files: newArray.length > 0 ? newArray : null}));
  };
  const handleRemoveFileVehicle = (index) => {
    let newArrayVehicle = Array.from(filesDataVehicle).filter((elem, idx) => index !== idx);
    dispatch(setSendData({vehicle_files: newArrayVehicle.length > 0 ? newArrayVehicle : null}));
  };
  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
  };
  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    const filteredFiles = Array.from(files).filter(
      (item) =>
        item.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
    const otherTypes = Array.from(files).filter(
      (item) =>
        item.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
    dispatch(setSendData({files: filteredFiles}));

    if (otherTypes.length > 0) {
      showToast("Please enter only excel type file", "error");
    }
  };

  return (
    <div className='verify__inner'>
      <div className="verify__vehicle">
        <div className="verify__vehicle-header">
          <div className="verify__vehicle-title">
            Additional files <span>(Optional)</span>
          </div>
          <div className="verify__vehicle-info">
            <img
              data-tooltip-id="vehicle-info"
              data-tooltip-content={tooltipText}
              src="/assets/icons/info.svg"
              alt="info"
            />
            <Tooltip place="bottom-end" id="vehicle-info"/>
          </div>
        </div>
        <div className="verify__vehicle-upload">
          <input
            type="file"
            id="files"
            accept=".jpg, .jpeg, .svg, .png, .gif, .docx, .doc, .pdf"
            onChange={uploadHandler}
            multiple={true}
            ref={fileInputRef}
          />
          <label onDragOver={handleDragOver} onDrop={handleDrop} htmlFor="files">
            <img src="/assets/icons/document.svg" alt="document"/>
            <div>Select a file to upload</div>
            <span>or drag and drop it here</span>
          </label>
        </div>
        <div className="verify__vehicle-list">
          {filesData?.length > 0 &&
          Array.from(filesData)?.map((item, index) => (
            <div className="verify__vehicle-item" key={index}>
              <div>
                <div className="type">
                  <img src="/assets/icons/document.svg" alt="excel"/>
                </div>
                <div className="info">
                  <div className="name">{item?.name}</div>
                  <div className="size">
                    {(item?.size / 1024 > 1024
                        ? item?.size / 1024 / 1024
                        : item?.size / 1024
                    ).toFixed(2)}
                    {item?.size / 1024 > 1024 ? "mb" : "kb"}
                  </div>
                </div>
              </div>
              <div className="close" onClick={() => handleRemoveFile(index)}>
                <img src="/assets/icons/close.svg" alt="close"/>
              </div>
            </div>
          ))}
        </div>
      </div>
      {
        accountData?.show_vehicle_forms ? (
          <div className="verify__vehicle">
            <div className="verify__vehicle-header">
              <div className="verify__vehicle-title">
                Vehicle info <span>(Optional)</span>
              </div>
              <div className="verify__vehicle-info">
                <img
                  data-tooltip-id="vehicle-info"
                  data-tooltip-content={tooltipText}
                  src="/assets/icons/info.svg"
                  alt="info"
                />
                <Tooltip place="bottom-end" id="vehicle-info"/>
              </div>
            </div>
            <div className="verify__vehicle-upload">
              <input
                type="file"
                id="files2"
                onChange={uploadHandlerVehicle}
                multiple={true}
                accept=".xls, .xlsx"
                ref={fileInputRef}
              />
              <label onDragOver={handleDragOver} onDrop={handleDrop} htmlFor="files2">
                <img src="/assets/icons/excel-file.svg" alt="document"/>
                <div>Select a file to upload</div>
                <span>or drag and drop it here</span>
              </label>
            </div>
            <div className="verify__vehicle-list">
              {filesDataVehicle?.length > 0 &&
              Array.from(filesDataVehicle)?.map((item, index) => (
                <div className="verify__vehicle-item" key={index}>
                  <div>
                    <div className="type">
                      <img src="/assets/icons/document.svg" alt="excel"/>
                    </div>
                    <div className="info">
                      <div className="name">{item?.name}</div>
                      <div className="size">
                        {(item?.size / 1024 > 1024
                            ? item?.size / 1024 / 1024
                            : item?.size / 1024
                        ).toFixed(2)}
                        {item?.size / 1024 > 1024 ? "mb" : "kb"}
                      </div>
                    </div>
                  </div>
                  <div className="close" onClick={() => handleRemoveFileVehicle(index)}>
                    <img src="/assets/icons/close.svg" alt="close"/>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : ''
      }
    </div>
  );
};